export const validateInput = (input) => {
  const codeRegex = /^\d{4}-\d{4}-\d{4}-\d{4}$/;

  // Regex for only alphanumeric characters
  const alphaNumericRegex = /^[a-zA-Z0-9-]+$/;

  // Test if input matches the code format
  const isCode = codeRegex.test(input);

  // Test if input contains only alphanumeric characters
  const isAlphaNumeric = alphaNumericRegex.test(input);

  // Determine if the input is invalid
  const isInvalid = !isCode && !isAlphaNumeric;

  return {
    // True if input matches code format
    isCode,
    // True if input contains only alphanumeric characters and hyphens
    isAlphaNumeric,
    // True if input is invalid
    isInvalid,
  };
};
